import * as types from "./ActionTypes";
import Api from "../api/VirtualUserApi";
import "regenerator-runtime/runtime";

/* update user */
export function updateCurrentUser (user) {
    return function (dispatch) {
        return Api.updateCurrentUser(user)
            .then(() => {
                dispatch(updateCurrentUserSucceeded(user));
            })
            .catch((error) => {
                dispatch(updateCurrentUserFailed(error));
                throw(error);
            });
    };
}

export function verifyUserEmail (user, newEmail) {
    return (dispatch) => {
        dispatch({ type: types.BEGIN_AJAX_CALL });
        return Api.verifyUserEmail(user.id, newEmail)
            .then((updatedUser) => {
                dispatch(updateCurrentUserSucceeded(updatedUser));
                dispatch({ type: types.CURRENT_USER_VERIFICATION_EMAIL_RESENT });
            })
            .catch((error) => {
                dispatch(updateCurrentUserFailed(error));
                throw(error);
            }).finally(() => {
                dispatch({ type: types.END_AJAX_CALL });
            });
    };
}

export const discardChanges = (user) => {
    return function (dispatch) {
        dispatch({ type: types.BEGIN_AJAX_CALL });
        return Api.discardEmailChanges(user.id)
            .then((updatedUser) => {
                dispatch(updateCurrentUserSucceeded(updatedUser));
            })
            .catch((error) => {
                dispatch(updateCurrentUserFailed(error));
                throw(error);
            }).finally(() => {
                dispatch({ type: types.END_AJAX_CALL });
            });
    };
};

export function getVirtualUsersByOrgId (orgId, virtualProductid, filterByAssignedOrganizationId) {
    return function (dispatch) {
        return Api.getVirtualUsersByOrgId(orgId, virtualProductid, filterByAssignedOrganizationId)
            .then(function (virtualUsers) {
                return dispatch({ type: types.GET_VIRTUAL_USERS_BY_ORG_SUCCEEDED, virtualUsers });
            })
            .catch((error) => {
                dispatch({ type: types.GET_VIRTUAL_USERS_BY_ORG_FAILED, error });
                throw(error);
            });
    };
}

function updateCurrentUserSucceeded (virtualUser) {
    window.virtualUser = virtualUser;
    return { type: types.UPDATE_CURRENT_USER_PROFILE_SUCCEEDED, virtualUser };
}

function updateCurrentUserFailed (error) {
    return { type: types.UPDATE_CURRENT_USER_PROFILE_FAILED, error };
}

export const updateExternalIds = (user, externalIdentifiers) => async dispatch => {
    try {
        user.externalIdentifiers = await Api.updateExternalIds(user.id, externalIdentifiers);
        return dispatch(updateCurrentUserSucceeded(user));
    }
    catch (error) {
        dispatch(updateCurrentUserFailed(error));
        throw(error);
    }
};

export const getNabpRoles = () => async dispatch => {
    try {
        const nabpRoles = await Api.getNabpRoles();
        return dispatch({ type: types.GET_NABP_ROLES_SUCCEEDED, nabpRoles: nabpRoles });
    }
    catch (error) {
        dispatch(updateCurrentUserFailed(error));
        throw(error);
    }
};
